module.exports = __webpack_public_path__ + "img/img06.c4fb3f6c.png";